import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AloCatalogReference } from '@/models/alo/AloCatalogReference'
import { AxiosPromise } from 'axios'
import { AloBase } from '@/models/alo/AloBase'
import { AloCatalogTree } from '@/models/alo/AloCatalogTree'
import { AloMarque } from '@/models/alo/AloMarque'


export default {
  getCatalogMarque(): AxiosPromise<AlrContainer<Array<AloMarque>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/api/admin/CatalogMarque`, 
      method: 'GET',
      transformResponse: [function (data:string) {
        return JSON.parse(data) as AlrContainer<Array<AloMarque>>
      }]
    })
  },
  getCatalogReference():AxiosPromise<AlrContainer<AloCatalogReference>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/api/admin/CatalogReference`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloCatalogReference>
      }]
    })
  },
  getCatalogTree():AxiosPromise<AlrContainer<AloCatalogTree>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/api/admin/CatalogTree`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloCatalogTree>
      }]
    })
  },
}